import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import numeral from "numeral";

Vue.config.productionTip = false;

axios.defaults.baseURL = `${process.env.VUE_APP_URL_API}/api`;

axios.interceptors.response.use(undefined, error => {
  if (error.response.status === 403) {
    store.dispatch("logout");
  }

  return Promise.reject(error);
});

store.dispatch("tryAutoLogin");

numeral.register("locale", "es", {
  delimiters: {
    thousands: ".",
    decimal: ","
  },
  currency: {
    symbol: "GPY"
  }
});
numeral.locale("es");

axios.interceptors.request.use(config => {
  if (store.getters.user) {
    config.headers.Authorization = store.getters.user.jwt;
  }
  return config;
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
